import {
  call,
  getContext,
  put,
  takeEvery,
  select,
  takeLatest,
} from "redux-saga/effects";
import { CONTEXT } from "@const/redux";

import {
  createLivestreamSuccess,
  createLivestreamFailure,
  endLivestreamSuccess,
  endLivestreamFailure,
  getLivestreamsSuccess,
  getLivestreamsFailure,
  joinLivestreamSuccess,
  joinLivestreamFailure,
  updateLivestreamSuccess,
  updateLivestreamFailure,
  sendMessageFailure,
  sendMessageSuccess,
  getMessagesSuccess,
  getMessagesFailure,
  getParticipantsSuccess,
  getParticipantsFailure,
  getNewMessageSuccess,
  getNewTipSuccess,
  getLivestreamDetailsSuccess,
  getLivestreamDetailsFailure,
  getUpdatedLivestreamDetailsSuccess,
  getParticipantsUpdateSuccess,
  leaveLivestreamSuccess,
  leaveLivestreamFailure,
  livestreamEndedSuccess,
  deleteMessageSuccess,
  deleteMessageFailure,
  changeParticipantRoleSuccess,
  changeParticipantRoleFailure,
  deleteAllParticipantMessagesSuccess,
  deleteAllParticipantMessagesFailure,
  handleDeleteMessageSuccess,
  handleDeleteAllParticipantMessagesSuccess,
  banParticipantSuccess,
  banParticipantFailure,
  handleBanParticipantSuccess,
  handleMuteParticipantSuccess,
  muteParticipantSuccess,
  muteParticipantFailure,
  reportStreamSuccess,
  reportStreamFailure,
  joinLivestream as joinLivestreamRequest,
  updateLivestreamPreviewImageSuccess,
  updateLivestreamPreviewImageFailure,
  getTopTippers as getTopTippersRequest,
  getTopTippersFailure,
  getTopTippersSuccess,
  getInviteListSuccess,
  getInviteListFailure,
  inviteParticipantSuccess,
  inviteParticipantFailure,
  handleInviteFromStreamerToViewerSuccess,
  acceptInviteSuccess,
  acceptInviteFailure,
  rejectInviteSuccess,
  rejectInviteFailure,
  requestInviteToCoStreamingSuccess,
  requestInviteToCoStreamingFailure,
  updateLivestreamGoalSuccess,
  updateLivestreamGoalFailure,
  updateLivestreamGoal,
  deleteLivestreamGoalSuccess,
  deleteLivestreamGoalFailure,
  deleteLivestreamGoal,
  handleHostAcceptedRequestToCoStreamingSuccess,
  startSpinTheBottle as startSpinTheBottleRequest,
  startSpinTheBottleSuccess,
  startSpinTheBottleFailure,
  endSpinTheBottle as endSpinTheBottleRequest,
  endSpinTheBottleSuccess,
  endSpinTheBottleFailure,
  spinTheBottle as spinTheBottleRequest,
  spinTheBottleSuccess,
  spinTheBottleFailure,
  makeCoStreamerAViewerSuccess,
  makeCoStreamerAViewerFailure,
  handleChangeCoStreamerRoleToViewerSuccess,
  rejectAllSuccess,
  rejectAllFailure,
  handleCoStreamerStartsStreamSuccess,
  getLivestreamsPortionSuccess,
  getLivestreamsPortionFailure,
} from "./actions";
import {
  acceptInviteActionTypes,
  banParticipantActionTypes,
  changeParticipantRoleActionTypes,
  createLivestreamActionTypes,
  deleteAllParticipantMessagesActionTypes,
  deleteMessageActionTypes,
  endLivestreamActionTypes,
  getInviteListActionTypes,
  getLivestreamDetailsActionTypes,
  getLivestreamsActionTypes,
  getLivestreamsPortionActionTypes,
  getMessagesActionTypes,
  getNewMessageActionTypes,
  getNewTipActionTypes,
  getParticipantsActionTypes,
  getParticipantsUpdateActionTypes,
  getTopTippersActionTypes,
  getUpdatedLivestreamDetailsActionTypes,
  handleBanParticipantActionTypes,
  handleChangeCoStreamerRoleToViewerActionTypes,
  handleCoStreamerStartsStreamActionTypes,
  handleDeleteAllParticipantMessagesActionTypes,
  handleDeleteMessageActionTypes,
  handleHostAcceptedRequestToCoStreamingActionTypes,
  handleInviteFromStreamerToViewerActionsTypes,
  handleMuteParticipantActionTypes,
  inviteParticipantActionTypes,
  joinLivestreamActionTypes,
  leaveLivestreamActionTypes,
  livestreamEndedActionTypes,
  makeCoStreamerAViewerActionTypes,
  muteParticipantActionTypes,
  rejectAllActionTypes,
  rejectInviteActionTypes,
  reportStreamActionTypes,
  requestInviteToCoStreamingActionTypes,
  sendMessageActionTypes,
  updateLivestreamActionTypes,
  updateLivestreamPreviewImageActionTypes,
} from "./actionTypes";
import {
  normalizeLivestreamArray,
  normalizeParticipantsArray,
} from "@helpers/livestreams";
import { getProfile } from "@redux/profile/actions";
import {
  gameTypes,
  listTypes,
  livestreamStatuses,
  messageTypes,
} from "@const/livestreams";
import { noop } from "@helpers/common";
import toastService from "@services/ToastService";
import { ErrorCodes } from "@const/errors";

const checkIsNotOnStreamError = (e, callback) => {
  if (e?.error?.message === "Participant is not on stream") callback?.();
};

const createLivestreamAsync = ({ LivestreamsService, payload }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.createStream(payload);
};

const startRecordingAsync = ({ LivestreamsService }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.startRecording();
};

const endLivestreamAsync = ({ LivestreamsService }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.endLivestream();
};
const getLivestreamsAsync = ({ LivestreamsService, params }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.getStreams(params);
};
const joinLivestreamAsync = ({ LivestreamsService, uniqueKey }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.joinStream({ uniqueKey });
};

const leaveLivestreamAsync = ({ LivestreamsService, uniqueKey }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.leaveStream({ uniqueKey });
};
const updateLivestreamAsync = ({ LivestreamsService, payload }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.updateStream(payload);
};

const sendMessageAsync = ({ LivestreamsService, uniqueKey, body }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.sendMessageToStream({ uniqueKey, body });
};

const getMessagesAsync = ({ LivestreamsService, uniqueKey, body }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.getStreamMessages({ uniqueKey, body });
};

const getParticipantsAsync = ({ LivestreamsService, uniqueKey, params }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.getParticipants({ uniqueKey, params });
};

const getTopTippersAsync = ({ LivestreamsService, uniqueKey }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.getParticipants({
    shouldKeep: true,
    uniqueKey,
    params: {
      listType: listTypes.tipper,
      limit: 3,
    },
  });
};

const changeParticipantRoleAsync = ({ LivestreamsService, id, body }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.changeParticipantRole({ id, body });
};
const deleteMessageAsync = ({ LivestreamsService, id }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.deleteMessage({ id });
};

const deleteAllParticipantMessagesAsync = ({ LivestreamsService, id }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.deleteAllParticipantMessages({ id });
};

const banParticipantAsync = ({ LivestreamsService, id }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.banParticipant({ id });
};

const reportStreamAsync = ({ LivestreamsService, id, report }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.reportStream({ id, report });
};

const updateStreamGoalAsync = ({ LivestreamsService, payload }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.updateStreamGoal(payload);
};

const deleteStreamGoalAsync = ({ LivestreamsService }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.deleteStreamGoal();
};

const startSpinTheBottleAsync = ({ LivestreamsService, uniqueKey }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.startGame({
    type: gameTypes.spinTheBottle,
    uniqueKey,
  });
};

const endSpinTheBottleAsync = ({ LivestreamsService, uniqueKey }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.endGame({
    type: gameTypes.spinTheBottle,
    uniqueKey,
  });
};

const spinTheBottleAsync = ({ LivestreamsService, uniqueKey, body }) => {
  if (!LivestreamsService) {
    return;
  }
  return LivestreamsService.spinTheBottle({
    uniqueKey,
    body,
  });
};

const muteParticipantAsync = ({ LivestreamsService, id }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.muteParticipant({ id });
};

const getLivestreamDetailsAsync = ({ LivestreamsService, uniqueKey }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.getLivestreamDetails({ uniqueKey });
};

const updateLivestreamPreviewImageAsync = ({
  LivestreamsService,
  previewImageId,
}) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.updateLivestreamPreviewImage({ previewImageId });
};
const getInviteListAsync = ({ LivestreamsService, uniqueKey, params }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.getInviteList({ uniqueKey, params });
};
const inviteParticipantAsync = ({ LivestreamsService, id }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.inviteParticipant({ id });
};

const acceptRejectInviteAsync = ({ LivestreamsService, id, actionType }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.acceptRejectInvite({ id, actionType });
};

const rejectAllAsync = ({ LivestreamsService }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.rejectAll();
};

const requestInviteToCoStreamingAsync = ({ LivestreamsService, uniqueKey }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.requestInviteToCoStreaming({ uniqueKey });
};
const makeCoStreamerAViewerAsync = ({ LivestreamsService, id }) => {
  if (!LivestreamsService) {
    return;
  }

  return LivestreamsService.makeCoStreamerAViewer({ id });
};

function* createLivestream({ payload }) {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(createLivestreamAsync, {
      LivestreamsService,
      payload,
    });

    yield put(createLivestreamSuccess(data));

    yield put(
      joinLivestreamRequest({ uniqueKey: data.uniqueKey, isHost: true }),
    );
  } catch (error) {
    console.log({ error });
    yield put(createLivestreamFailure(error));
  }
}

function* endLivestream({ payload }) {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(endLivestreamAsync, { LivestreamsService });

    yield put(endLivestreamSuccess());
    const { callback } = payload;
    callback ? callback() : null;
  } catch ({ error }) {
    yield put(endLivestreamFailure(error));
  }
}

function* joinLivestream({ payload }) {
  try {
    const { uniqueKey, isHost, streamGoal } = payload;

    const { activeStream } = yield select(
      ({ livestreamsReducer }) => livestreamsReducer,
    );
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);

    if (!activeStream?.id) {
      const { data } = yield call(getLivestreamDetailsAsync, {
        LivestreamsService,
        uniqueKey,
      });

      yield put(getLivestreamDetailsSuccess(data));
    }

    const { activeStream: activeStreamUpdated } = yield select(
      ({ livestreamsReducer }) => livestreamsReducer,
    );

    if (
      !!activeStreamUpdated?.id &&
      (activeStreamUpdated.status === livestreamStatuses.scheduled ||
        activeStreamUpdated.status === livestreamStatuses.live)
    ) {
      const { data } = yield call(joinLivestreamAsync, {
        LivestreamsService,
        uniqueKey,
      });
      yield put(joinLivestreamSuccess(data));
      try {
        if (isHost && !activeStreamUpdated?.startDate) {
          yield call(startRecordingAsync, { LivestreamsService });
        }
      } catch ({ error: recordingError }) {
        if (recordingError?.message) {
          console.error(recordingError?.message);
        }
      }

      if (streamGoal?.goal) {
        yield put(updateLivestreamGoal(streamGoal));
      }
    } else {
      yield put(joinLivestreamSuccess(activeStream));
    }
  } catch ({ error }) {
    const { ToasterService } = yield getContext(CONTEXT.SERVICES);
    if (error?.message) {
      ToasterService.error(error?.message);
    }
    yield put(joinLivestreamFailure(error));
  }
}

function* leaveLivestream({ payload }) {
  try {
    const { uniqueKey, callback } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(leaveLivestreamAsync, {
      LivestreamsService,
      uniqueKey,
    });

    yield put(leaveLivestreamSuccess(data));
    callback?.();
  } catch ({ error }) {
    yield put(leaveLivestreamFailure(error));
  }
}

function* updateLivestream({ payload }) {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(updateLivestreamAsync, {
      LivestreamsService,
      payload,
    });

    yield put(updateLivestreamSuccess(data));
  } catch ({ error }) {
    yield put(updateLivestreamFailure(error));
  }
}

function* getLivestreams({ payload }) {
  try {
    const { ...params } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data, pagination } = yield call(getLivestreamsAsync, {
      LivestreamsService,
      params,
    });

    const { entities, result: allLivestreams } = normalizeLivestreamArray(data);
    const { livestreams: livestreamsById } = entities;

    yield put(
      getLivestreamsSuccess({
        livestreams: { allLivestreams, livestreamsById },
        pagination,
      }),
    );
  } catch ({ error }) {
    yield put(getLivestreamsFailure(error));
  }
}

function* getLivestreamsPortion({ payload }) {
  try {
    const { ...params } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data, pagination } = yield call(getLivestreamsAsync, {
      LivestreamsService,
      params,
    });

    const { entities, result: allLivestreams } = normalizeLivestreamArray(data);
    const { livestreams: livestreamsById } = entities;

    yield put(
      getLivestreamsPortionSuccess({
        livestreams: { allLivestreams, livestreamsById },
        pagination,
      }),
    );
  } catch ({ error }) {
    yield put(getLivestreamsPortionFailure(error));
  }
}

function* sendMessage({ payload }) {
  try {
    const { uniqueKey, body, callBack = noop } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data: message } = yield call(sendMessageAsync, {
      LivestreamsService,
      uniqueKey,
      body,
    });

    callBack();
    yield put(
      sendMessageSuccess({
        message,
      }),
    );
  } catch ({ error }) {
    const { ToasterService } = yield getContext(CONTEXT.SERVICES);
    yield put(sendMessageFailure(error));
    ToasterService.errorTranslated("MSG_WAS_NOT_SENT");
  }
}

function* getMessages({ payload }) {
  try {
    const { uniqueKey, body } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data: messages } = yield call(getMessagesAsync, {
      LivestreamsService,
      uniqueKey,
      body,
    });

    yield put(
      getMessagesSuccess({
        messages,
        uuid: payload.uuid,
      }),
    );
  } catch ({ error }) {
    yield put(getMessagesFailure(error));
  }
}

function* getParticipants({ payload }) {
  try {
    const { uniqueKey, params } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const {
      data: participants,
      pagination: { totalCount },
    } = yield call(getParticipantsAsync, {
      LivestreamsService,
      uniqueKey,
      params,
    });

    const { allParticipants, participantsById } =
      normalizeParticipantsArray(participants);

    yield put(
      getParticipantsSuccess({
        allParticipants,
        participantsById,
        totalCount,
      }),
    );
  } catch (error) {
    yield put(getParticipantsFailure(error));
  }
}
function* getTopTippers({ payload }) {
  try {
    const { uniqueKey } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(getTopTippersAsync, {
      LivestreamsService,
      uniqueKey,
    });

    yield put(getTopTippersSuccess(data));
  } catch (error) {
    yield put(getTopTippersFailure(error));
  }
}

function* changeParticipantRole({ payload }) {
  const { id, body, errorCallback } = payload;

  try {
    const { chat } = yield select(
      ({ livestreamsReducer }) => livestreamsReducer,
    );
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(changeParticipantRoleAsync, {
      LivestreamsService,
      id,
      body,
    });
    const updatedMessages = chat.messages.map((message) => {
      if (message?.streamParticipant?.id === data.id) {
        return {
          ...message,
          streamParticipant: { ...message.streamParticipant, role: data.role },
        };
      }
      return { ...message };
    });

    yield put(
      changeParticipantRoleSuccess({
        messages: updatedMessages,
        participant: data,
      }),
    );
  } catch (e) {
    checkIsNotOnStreamError(e, errorCallback);
    yield put(changeParticipantRoleFailure(e));
  }
}

function* deleteMessage({ payload }) {
  try {
    const { id } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(deleteMessageAsync, {
      LivestreamsService,
      id,
    });
    const { chat } = yield select(
      ({ livestreamsReducer }) => livestreamsReducer,
    );

    const updatedMessages = chat.messages.filter(
      (message) => message.id !== id,
    );

    yield put(deleteMessageSuccess(updatedMessages));
  } catch (error) {
    yield put(deleteMessageFailure(error));
  }
}

function* deleteAllParticipantMessages({ payload }) {
  try {
    const { id } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(deleteAllParticipantMessagesAsync, {
      LivestreamsService,
      id,
    });
    const { chat } = yield select(
      ({ livestreamsReducer }) => livestreamsReducer,
    );

    const updatedMessages = chat.messages.filter(
      (message) => message.streamParticipant.id !== id,
    );

    yield put(deleteAllParticipantMessagesSuccess(updatedMessages));
  } catch (error) {
    yield put(deleteAllParticipantMessagesFailure(error));
  }
}

function* banParticipant({ payload }) {
  const { id, listType, totalTipsAmount, errorCallback } = payload;
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(banParticipantAsync, {
      LivestreamsService,
      id,
    });

    yield put(banParticipantSuccess({ id, listType, totalTipsAmount }));
  } catch (e) {
    checkIsNotOnStreamError(e, errorCallback);
    yield put(banParticipantFailure(e));
  }
}

function* reportStream({ payload }) {
  try {
    const { id, report } = payload;
    const { LivestreamsService, ToasterService } = yield getContext(
      CONTEXT.SERVICES,
    );
    yield call(reportStreamAsync, {
      LivestreamsService,
      id,
      report,
    });

    yield put(reportStreamSuccess());
    ToasterService.success(
      "Your report has been received, thank you for letting us know",
    );
  } catch (error) {
    yield put(reportStreamFailure(error));
  }
}

function* muteParticipant({ payload }) {
  const { id, errorCallback } = payload;
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(muteParticipantAsync, {
      LivestreamsService,
      id,
    });

    yield put(muteParticipantSuccess());
  } catch (e) {
    checkIsNotOnStreamError(e, errorCallback);
    yield put(muteParticipantFailure(e));
  }
}

function* getLivestreamDetails({ payload }) {
  try {
    const { uniqueKey } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(getLivestreamDetailsAsync, {
      LivestreamsService,
      uniqueKey,
    });

    yield put(getLivestreamDetailsSuccess(data));
  } catch (error) {
    yield put(getLivestreamDetailsFailure(error));
  }
}
function* updateLivestreamPreviewImage({ payload }) {
  try {
    const { previewImageId } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(updateLivestreamPreviewImageAsync, {
      LivestreamsService,
      previewImageId,
    });

    yield put(updateLivestreamPreviewImageSuccess(data));
  } catch (error) {
    yield put(updateLivestreamPreviewImageFailure(error));
  }
}

function* getInviteList({ payload }) {
  try {
    const { uniqueKey, params } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(getInviteListAsync, {
      LivestreamsService,
      uniqueKey,
      params,
    });

    yield put(getInviteListSuccess(data));
  } catch (error) {
    yield put(getInviteListFailure(error));
  }
}
function* inviteParticipant({ payload }) {
  try {
    const { id } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(inviteParticipantAsync, {
      LivestreamsService,
      id,
    });

    yield put(inviteParticipantSuccess({ id, data }));
  } catch (e) {
    if (e?.error?.message === ErrorCodes.MAX_ACTIVE_STREAM_INVITES) {
      toastService.errorTranslated("MAX_ACTIVE_STREAM_INVITES");
    }
    yield put(inviteParticipantFailure(e));
  }
}

function* acceptInvite({ payload }) {
  try {
    const { id } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(acceptRejectInviteAsync, {
      LivestreamsService,
      id,
      actionType: 1,
    });

    yield put(acceptInviteSuccess({ id }));
  } catch (error) {
    yield put(acceptInviteFailure(error));
  }
}

function* rejectInvite({ payload }) {
  const { id } = payload;

  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(acceptRejectInviteAsync, {
      LivestreamsService,
      id,
      actionType: 2,
    });

    yield put(rejectInviteSuccess({ id }));
  } catch (error) {
    yield put(rejectInviteFailure({ id }));
  }
}
function* rejectAll() {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(rejectAllAsync, {
      LivestreamsService,
    });

    yield put(rejectAllSuccess());
  } catch (error) {
    yield put(rejectAllFailure());
  }
}

function* requestInviteToCoStreaming({ payload }) {
  try {
    const { uniqueKey } = payload;
    const { LivestreamsService, ToasterService } = yield getContext(
      CONTEXT.SERVICES,
    );
    yield call(requestInviteToCoStreamingAsync, {
      LivestreamsService,
      uniqueKey,
    });

    yield put(requestInviteToCoStreamingSuccess());
    ToasterService.successTranslated("REQUEST_SUCCESSFULLY_SENT", "livestream");
  } catch (error) {
    yield put(requestInviteToCoStreamingFailure(error));
  }
}

function* makeCoStreamerAViewer({ payload }) {
  try {
    const { id } = payload;
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(makeCoStreamerAViewerAsync, {
      LivestreamsService,
      id,
    });

    yield put(makeCoStreamerAViewerSuccess());
  } catch (error) {
    yield put(makeCoStreamerAViewerFailure(error));
  }
}

function* getNewMessage({ payload }) {
  const { message } = payload;
  const { activeStream } = yield select(
    ({ livestreamsReducer }) => livestreamsReducer,
  );
  yield put(getProfile());
  const amountsList = yield call(() =>
    import("@pages/Livestream/components/SendTip/form").then(
      async (m) => await m.getAmountsList(),
    ),
  );
  yield put(getNewMessageSuccess({ message, amountsList }));
  const isTip = message.type === messageTypes.tip;
  if (!isTip) return;
  yield put(getTopTippersRequest({ uniqueKey: activeStream.uniqueKey }));
}

function* getUpdatedLivestreamDetails({ payload }) {
  const { stream } = payload;

  yield put(getUpdatedLivestreamDetailsSuccess(stream));
}

function* getParticipantsUpdate({ payload }) {
  const { participant } = payload;
  yield put(getParticipantsUpdateSuccess({ participant }));
}

function* handleDeleteMessage({ payload }) {
  const { deletedMessageId } = payload;

  yield put(handleDeleteMessageSuccess({ deletedMessageId }));
}

function* handleChangeCoStreamerRoleToViewer({ payload }) {
  console.log("handleChangeCoStreamerRoleToViewer", payload);
  const { participant } = payload;

  yield put(handleChangeCoStreamerRoleToViewerSuccess({ participant }));
}

function* handleBanParticipant({ payload }) {
  const { participant } = payload;

  yield put(handleBanParticipantSuccess({ participant }));
}
function* handleMuteParticipant({ payload }) {
  const { participant } = payload;

  yield put(handleMuteParticipantSuccess({ participant }));
}

function* handleDeleteAllParticipantMessages({ payload }) {
  const { streamParticipantId } = payload;

  yield put(handleDeleteAllParticipantMessagesSuccess({ streamParticipantId }));
}

function* handleInviteFromStreamerToViewer({ payload }) {
  yield put(handleInviteFromStreamerToViewerSuccess(payload));
}

function* handleHostAcceptedRequestToCoStreaming({ payload }) {
  yield put(handleHostAcceptedRequestToCoStreamingSuccess(payload));
}

function* handleCoStreamerStartsStream({ payload }) {
  yield put(handleCoStreamerStartsStreamSuccess(payload));
}

function* livestreamEnded({ payload }) {
  const { stream } = payload;

  yield put(livestreamEndedSuccess(stream));
}

function* updateStreamGoal({ payload }) {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const updatedGoal = yield call(updateStreamGoalAsync, {
      LivestreamsService,
      payload,
    });
    yield put(updateLivestreamGoalSuccess(updatedGoal.data));
  } catch (error) {
    yield put(updateLivestreamGoalFailure(error));
  }
}

function* deleteStreamGoal() {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(deleteStreamGoalAsync, {
      LivestreamsService,
    });
    yield put(deleteLivestreamGoalSuccess());
  } catch (error) {
    yield put(deleteLivestreamGoalFailure(error));
  }
}

function* startSpinTheBottle({ payload }) {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(startSpinTheBottleAsync, {
      LivestreamsService,
      uniqueKey: payload,
    });
    yield put(startSpinTheBottleSuccess());
  } catch (error) {
    yield put(startSpinTheBottleFailure(error));
  }
}

function* endSpinTheBottle({ payload }) {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(endSpinTheBottleAsync, {
      LivestreamsService,
      uniqueKey: payload,
    });
    yield put(endSpinTheBottleSuccess());
  } catch (error) {
    yield put(endSpinTheBottleFailure(error));
  }
}

function* spinTheBottle({ payload }) {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    yield call(spinTheBottleAsync, {
      LivestreamsService,
      uniqueKey: payload.uniqueKey,
      body: payload.body,
    });
    yield put(spinTheBottleSuccess());
  } catch (error) {
    yield put(spinTheBottleFailure(error));
  }
}

function* getNewTip({ payload }) {
  const { message } = payload;

  yield put(getNewTipSuccess(message));
}

export function* watchCreateLivestream() {
  yield takeEvery(createLivestreamActionTypes.request, createLivestream);
}

export function* watchEndLivestream() {
  yield takeEvery(endLivestreamActionTypes.request, endLivestream);
}
export function* watchGetLivestreams() {
  yield takeLatest(getLivestreamsActionTypes.request, getLivestreams);
}
export function* watchGetLivestreamsPortion() {
  yield takeLatest(
    getLivestreamsPortionActionTypes.request,
    getLivestreamsPortion,
  );
}
export function* watchJoinLivestream() {
  yield takeEvery(joinLivestreamActionTypes.request, joinLivestream);
}

export function* watchLeaveLivestream() {
  yield takeEvery(leaveLivestreamActionTypes.request, leaveLivestream);
}
export function* watchUpdateLivestream() {
  yield takeEvery(updateLivestreamActionTypes.request, updateLivestream);
}

export function* watchSendMessageToLivestream() {
  yield takeEvery(sendMessageActionTypes.request, sendMessage);
}

export function* watchGetMessagesForLivestream() {
  yield takeEvery(getMessagesActionTypes.request, getMessages);
}

export function* watchGetParticipants() {
  yield takeEvery(getParticipantsActionTypes.request, getParticipants);
}
export function* watchGetTopTippers() {
  yield takeEvery(getTopTippersActionTypes.request, getTopTippers);
}

export function* watchChangeParticipantRole() {
  yield takeEvery(
    changeParticipantRoleActionTypes.request,
    changeParticipantRole,
  );
}

export function* watchDeleteLivestreamMessage() {
  yield takeEvery(deleteMessageActionTypes.request, deleteMessage);
}
export function* watchDeleteAllParticipantMessages() {
  yield takeEvery(
    deleteAllParticipantMessagesActionTypes.request,
    deleteAllParticipantMessages,
  );
}

export function* watchBanParticipant() {
  yield takeEvery(banParticipantActionTypes.request, banParticipant);
}

export function* watchReportStream() {
  yield takeEvery(reportStreamActionTypes.request, reportStream);
}

export function* watchMuteParticipant() {
  yield takeEvery(muteParticipantActionTypes.request, muteParticipant);
}

// sockets watchers
export function* watchGetNewMessage() {
  yield takeEvery(getNewMessageActionTypes.request, getNewMessage);
}
export function* watchGetNewTip() {
  yield takeEvery(getNewTipActionTypes.request, getNewTip);
}
export function* watchGetLivestreamDetails() {
  yield takeEvery(
    getLivestreamDetailsActionTypes.request,
    getLivestreamDetails,
  );
}
export function* watchGetUpdatedLivestreamDetails() {
  yield takeEvery(
    getUpdatedLivestreamDetailsActionTypes.request,
    getUpdatedLivestreamDetails,
  );
}
export function* watchGetParticipantsUpdate() {
  yield takeEvery(
    getParticipantsUpdateActionTypes.request,
    getParticipantsUpdate,
  );
}

export function* watchHandleDeleteMessage() {
  yield takeEvery(handleDeleteMessageActionTypes.request, handleDeleteMessage);
}
export function* watchHandleChangeCoStreamerRoleToViewer() {
  yield takeEvery(
    handleChangeCoStreamerRoleToViewerActionTypes.request,
    handleChangeCoStreamerRoleToViewer,
  );
}

export function* watchHandleInviteFromStreamerToViewer() {
  yield takeEvery(
    handleInviteFromStreamerToViewerActionsTypes.request,
    handleInviteFromStreamerToViewer,
  );
}
export function* watchHandleHostAcceptedRequestToCoStreaming() {
  yield takeEvery(
    handleHostAcceptedRequestToCoStreamingActionTypes.request,
    handleHostAcceptedRequestToCoStreaming,
  );
}
export function* watchHandleCoStreamerStartsStream() {
  yield takeEvery(
    handleCoStreamerStartsStreamActionTypes.request,
    handleCoStreamerStartsStream,
  );
}

export function* watchHandleBanParticipant() {
  yield takeEvery(
    handleBanParticipantActionTypes.request,
    handleBanParticipant,
  );
}
export function* watchHandleMuteParticipant() {
  yield takeEvery(
    handleMuteParticipantActionTypes.request,
    handleMuteParticipant,
  );
}
export function* watchHandleDeleteAllParticipantMessages() {
  yield takeEvery(
    handleDeleteAllParticipantMessagesActionTypes.request,
    handleDeleteAllParticipantMessages,
  );
}
export function* watchLivestreamEnded() {
  yield takeEvery(livestreamEndedActionTypes.request, livestreamEnded);
}
export function* watchUpdateLivestreamPreview() {
  yield takeEvery(
    updateLivestreamPreviewImageActionTypes.request,
    updateLivestreamPreviewImage,
  );
}
export function* watchGetInviteList() {
  yield takeEvery(getInviteListActionTypes.request, getInviteList);
}
export function* watchInviteParticipant() {
  yield takeEvery(inviteParticipantActionTypes.request, inviteParticipant);
}
export function* watchAcceptInvite() {
  yield takeEvery(acceptInviteActionTypes.request, acceptInvite);
}
export function* watchRejectInvite() {
  yield takeEvery(rejectInviteActionTypes.request, rejectInvite);
}

export function* watchRejectAll() {
  yield takeEvery(rejectAllActionTypes.request, rejectAll);
}

export function* watchRequestInviteToCoStreaming() {
  yield takeEvery(
    requestInviteToCoStreamingActionTypes.request,
    requestInviteToCoStreaming,
  );
}
export function* watchMakeCoStreamerAViewer() {
  yield takeEvery(
    makeCoStreamerAViewerActionTypes.request,
    makeCoStreamerAViewer,
  );
}
export function* watchUpdateLivestreamGoal() {
  yield takeEvery(updateLivestreamGoal, updateStreamGoal);
}
export function* watchDeleteLivestreamGoal() {
  yield takeEvery(deleteLivestreamGoal, deleteStreamGoal);
}
export function* watchStartSpinTheBottle() {
  yield takeEvery(startSpinTheBottleRequest, startSpinTheBottle);
}
export function* watchEndSpinTheBottle() {
  yield takeEvery(endSpinTheBottleRequest, endSpinTheBottle);
}
export function* watchSpinTheBottle() {
  yield takeEvery(spinTheBottleRequest, spinTheBottle);
}
